<div class="bs-paperless-enrollment-req">
    <div class="bs-enroll-request-card">
        <div class="bs-desktop">
            <div class="request-card-title">{{"Your paperless enrollment request has been sent."}}</div>
            <div class="request-card-desc">{{"If you have any questions or you didn’t make this change contact our"}} 
                <span>
                    <a href="https://www.mapfreinsurance.com/contact/" target="_blank" class="mapfre link stuffer-underline red-link dm-sans-medium ">{{"customer service department"}}</a>
                </span>.
            </div>
        </div>
        
        <div>
            <div class="bs-activate dm-sans-medium mb10">
                <div>{{"Now activate your"}} </div>
                <div class="bs-ml-6">{{"Mapfre Customer Account to:"}}</div>
            </div>
            <ul class="mb-30">
                <li>View documents</li>
                <li>Manage payments</li>
                <li>Manage your policy</li>
            </ul>
        </div>
        <div>
            <mapfre-button
                [routerLink]="['/login']"
              additionalClasses="basic primary h56 large-btn"               
            >{{"Activate your account" | translate}}
          </mapfre-button>
        </div>
    </div>
    <div class="bs-bg-with-content">
        <div class="bs-mobile">
            <div class="request-card-title">{{"Your paperless enrollment request has been sent."}}</div>
            <div class="bs-confirm-text">{{"A confirmation message will be sent shortly."}}</div>
        </div>        
        <div class="bs-man-bg-image"></div>
    </div>
</div>